import { useIntl } from 'react-intl';
import type { CartItemDto, DeliveryReceiptRequestDto } from '@ordr-as/ordr-service-types/epos';
import { usePrintDirectReceipt } from '@ordr-as/ordr-service-types/epos';
import PrintForm from '../../../../components/ReceiptForm/PrintForm';
import { useLocation } from '../../../../context/LocationContext';
import { useCheckout } from '../../../../context/CheckoutContext';
import { useCartStore } from '../../../../context/cart/CartStore';

interface Props {
  customerName: string | undefined;
  referencePerson: string | undefined;
}

const PrintInvoiceDeliveryReceipt = (props: Props) => {
  const { customerName, referencePerson } = props;
  const { location } = useLocation();
  const { formatMessage } = useIntl();
  const { orderLines } = useCartStore((state) => ({
    orderLines: state.cart.orderLines,
  }));

  const { deliveryMethod } = useCheckout();
  const { mutate: printDeliveryReceipt, isPending } = usePrintDirectReceipt();

  const handlePrint = (placementId: number) => {
    const cartItems: CartItemDto[] = orderLines.map((orderLine) => ({
      deliveryType: deliveryMethod.type,
      itemVariantId: orderLine.itemVariantId,
      menuSectionId: orderLine.menuSectionId ?? '',
      openPrice: orderLine.openPrice ?? false,
      options: orderLine.options.map((option) => ({
        optionId: option.id ?? '',
        quantity: option.quantity,
      })),
      price: orderLine.price,
      quantity: orderLine.quantity,
      sectionProductId: orderLine.sectionProductId ?? '',
    }));

    const deliveryReceiptRequest: DeliveryReceiptRequestDto = {
      caller: 'epos',
      cartItems,
      customerName,
      customerReferencePerson: referencePerson,
      invoice: true,
      locationId: location.id,
      locationIds: [location.id],
      orderNumbers: [],
    };
    printDeliveryReceipt({
      data: deliveryReceiptRequest,
      orderReference: crypto.randomUUID(),
      placementId,
    });
  };

  return (
    <PrintForm
      handlePrint={handlePrint}
      isDisabled={isPending}
      buttonLabel={formatMessage({ id: 'generic.printBill' })}
    />
  );
};

export default PrintInvoiceDeliveryReceipt;
